import { SearchClientFactory } from "../../../services/SearchClientFactory";

/**
 * Affiche le nombre de recherches récentes disponibles
 */
export function displayRecentSearches(recentSearchesPlugin: any) {
    return () => {
        if (recentSearchesPlugin.data) {
            const recentSearches = recentSearchesPlugin.data.getAll();
            return Array.isArray(recentSearches) ? recentSearches.length : 0;
        } else {
            return 0;
        }
    };
}

/**
 * Créer un client de recherche optimisé pour l'autocomplete
 */
export function createAutocompleteClient(
    searchConfig: any,
    defaultSearchClient: any,
) {
    // Si c'est Typesense, utiliser le client spécialisé autocomplete
    if (searchConfig.driver === "typesense") {
        return SearchClientFactory.createAutocompleteClient(searchConfig);
    }

    // Sinon, utiliser le client par défaut (Algolia)
    return defaultSearchClient;
}

/**
 * Créer les données des marques avec leurs images
 */
export function createBrandData(brandImages: any) {
    return [
        {
            label: "Porsche",
            img: brandImages.porsche,
        },
        { label: "Ferrari", img: brandImages.ferrari },
        { label: "Audi", img: brandImages.audi },
        {
            label: "Mercedes",
            img: brandImages.mercedes,
        },
        { label: "McLaren", img: brandImages.mclaren },
        {
            label: "Lamborghini",
            img: brandImages.lamborghini,
        },
    ];
}
